module.exports = __webpack_public_path__ + "static/media/banner_popfans_web.651fd4aa.png";